module.exports = __webpack_public_path__ + "static/img/zichanpeizhi_bg.3edd50b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zichanpeizhi_bg.jpg
// module id = iLcd
// module chunks = 1